module.exports = __webpack_public_path__ + "static/img/JP.909a519.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/assets/img/countries/JP.svg
// module id = BqOn
// module chunks = 1